module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "site-footer",
    attrs: {
      "context": "site-footer"
    }
  }, [(_vm.PreviewService.getPreviewConfig()) ? [_c('sk-preview-footer', {
    attrs: {
      "config": _vm.PreviewService.getPreviewConfig()
    }
  })] : _vm._e(), _vm._v(" "), _c('sk-container', [_c('sk-layout', {
    staticClass: "site-footer__top",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "site-footer__club-cards"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "site-footer__club-cards-img"
  }, [(_vm.isGuest) ? [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-club-cards.png",
      "alt": ""
    }
  })] : [(_vm.isFanClub) ? [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/fan_club_card.png",
      "alt": ""
    }
  })] : [(_vm.isMorviesClub) ? [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/morvies_club_card.png",
      "alt": ""
    }
  })] : [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs_club_cards.png",
      "alt": ""
    }
  })]]]], 2)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "site-footer__club-cards-content"
  }, [(_vm.isGuest) ? [_c('div', {
    staticClass: "site-footer__club-cards-title"
  }, [_vm._v("\n                                      Ready for SK Subscription Club?\n                                  ")]), _vm._v(" "), _c('p', {
    staticClass: "site-footer__club-cards-copy"
  }, [_vm._v("\n                                      Subscribe today and watch even more movies, for less.\n                                  ")])] : [(_vm.isFanClub) ? [_c('div', {
    staticClass: "site-footer__club-cards-title"
  }, [_vm._v("\n                                          The fine print and the nitty gritties\n                                      ")]), _vm._v(" "), _c('p', {
    staticClass: "site-footer__club-cards-copy"
  }, [_vm._v("\n                                          Get clued up on the SK Subscription CLUB Ts & Cs to understand exactly how your subscription works.\n                                      ")])] : [(_vm.isMorviesClub) ? [_c('div', {
    staticClass: "site-footer__club-cards-title"
  }, [_vm._v("\n                                              The fine print and the nitty gritties\n                                          ")]), _vm._v(" "), _c('p', {
    staticClass: "site-footer__club-cards-copy"
  }, [_vm._v("\n                                              Get clued up on the SK Subscription CLUB Ts & Cs to understand exactly how your subscription works.\n                                          ")])] : [_c('div', {
    staticClass: "site-footer__club-cards-title"
  }, [_vm._v("\n                                              Ready for SK Subscription Club?\n                                          ")]), _vm._v(" "), _c('p', {
    staticClass: "site-footer__club-cards-copy"
  }, [_vm._v("\n                                              Subscribe today and watch even more movies, for less.\n                                          ")])]]]], 2), _vm._v(" "), _c('div', {
    staticClass: "site-footer__club-cards-btns"
  }, [(_vm.isGuest) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "tertiary": "",
      "block": "",
      "tag": "a",
      "href": "/subscription-club"
    }
  }, [_vm._v("Tell Me More")])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "tag": "a",
      "href": "/subscription-club"
    }
  }, [_vm._v("Join Subscription Club")])], 1)], 1)] : [(_vm.isFanClub) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "tag": "a",
      "href": "/content/legal/Fan%20Club%20T's%20and%20C's"
    }
  }, [_vm._v("View the SK Subscription CLUB Ts & Cs")])], 1)], 1)] : [(_vm.isMorviesClub) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "tag": "a",
      "href": "/content/legal/Fan%20Club%20T's%20and%20C's"
    }
  }, [_vm._v("View the SK Subscription CLUB Ts & Cs")])], 1)], 1)] : [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "tertiary": "",
      "block": "",
      "tag": "a",
      "href": "/subscription-club"
    }
  }, [_vm._v("Tell Me More")])], 1)], 1)]]]], 2)])], 1)], 1)])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "site-footer__nav"
  }, [_c('sk-layout', {
    staticClass: "hidden-xs",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer--heading"
  }, [_vm._v("Get in Touch")]), _vm._v(" "), _c('sk-list', {
    staticClass: "footer--list"
  }, _vm._l((_vm.items), function(item, index) {
    return (item.footer == 1) ? _c('sk-list-item', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer--heading"
  }, [_c('a', {
    staticClass: "footer--heading--link",
    attrs: {
      "href": "/content/sales-at-sk/advertising"
    }
  }, [_vm._v("Sales at SK")])]), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return (item.footer == 2) ? _c('sk-list', {
      key: index,
      staticClass: "footer--list"
    }, _vm._l((item.children), function(child, index) {
      return _c('sk-list-item', {
        key: index
      }, [(!child.url) ? _c('sk-button', {
        attrs: {
          "link": "",
          "router": "",
          "to": {
            name: child.name
          },
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))]) : _c('sk-button', {
        attrs: {
          "link": "",
          "tag": "a",
          "href": child.url,
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))])], 1)
    })) : _vm._e()
  })], 2)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer--heading"
  }, [_vm._v("SK Corporate")]), _vm._v(" "), _c('sk-list', {
    staticClass: "footer--list"
  }, _vm._l((_vm.items), function(item, index) {
    return (item.footer == 3) ? _c('sk-list-item', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer--heading"
  }, [_vm._v("SK Clubs & Movie Cards")]), _vm._v(" "), _c('sk-list', {
    staticClass: "footer--list"
  }, _vm._l((_vm.items), function(item, index) {
    return (item.footer == 4) ? _c('sk-list-item', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer--heading"
  }, [_vm._v("Share the Experience")]), _vm._v(" "), _c('sk-list', {
    staticClass: "footer--list"
  }, _vm._l((_vm.items), function(item, index) {
    return (item.footer == 5) ? _c('sk-list-item', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('div', {
    staticClass: "footer footer-social"
  }, [_c('div', {
    staticClass: "footer--heading"
  }, [_vm._v("Social")]), _vm._v(" "), _c('sk-list', [_c('sk-list-item', [_c('sk-list-tile', {
    attrs: {
      "href": "https://www.facebook.com/sterkinekortheatres/",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "facebook": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', [_vm._v("\n                        Facebook\n                      ")])], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', {
    attrs: {
      "href": "https://twitter.com/sterkinekor",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "twitter": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', [_vm._v("\n                        Twitter\n                      ")])], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', {
    attrs: {
      "href": "https://www.instagram.com/sterkinekor/?hl=en",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "instagram": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', [_vm._v("\n                        Instagram\n                      ")])], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', {
    attrs: {
      "href": "https://www.youtube.com/user/SterKinekorTheatres",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "youtube": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', [_vm._v("\n                        Youtube\n                      ")])], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('sk-layout', [_c('sk-spacer', {
    attrs: {
      "height": "20"
    }
  })], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "hidden-xs"
  }, [_c('sk-flex', {
    staticClass: "footer-container",
    attrs: {
      "grow": ""
    }
  }, _vm._l((_vm.items), function(item, index) {
    return (item.footer == 6) ? _c('sk-list', {
      key: index,
      staticClass: "footer--list",
      attrs: {
        "inline": ""
      }
    }, [_c('sk-list-item', {}, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child, index) {
      return _c('sk-list-item', {
        key: index
      }, [(child.target != undefined) ? [(!child.url) ? _c('sk-button', {
        attrs: {
          "link": "",
          "router": "",
          "to": {
            name: child.name
          },
          "contextValue": "Footer Navigation",
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.name))]) : _c('sk-button', {
        attrs: {
          "link": "",
          "tag": "a",
          "href": child.url,
          "contextValue": "Footer Navigation",
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.name))])] : [(!child.url) ? _c('sk-button', {
        attrs: {
          "link": "",
          "router": "",
          "to": {
            name: child.name
          },
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))]) : _c('sk-button', {
        attrs: {
          "link": "",
          "tag": "a",
          "href": child.url,
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))])]], 2)
    })], 2) : _vm._e()
  }))], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "visible-xs",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-list', [_c('sk-list-group', [_c('sk-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('sk-list-tile-content', [_c('sk-list-tile-title', [_vm._v("Get in Touch")])], 1), _vm._v(" "), _c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "arrowDown": ""
    }
  })], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', [_c('sk-list-tile-content', _vm._l((_vm.items), function(item, index) {
    return (item.footer == 1) ? _c('sk-list-tile-title', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-list', [_c('sk-list-group', [_c('sk-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('sk-list-tile-content', [_c('sk-list-tile-title', [_c('a', {
    attrs: {
      "href": "/content/sales-at-sk/advertising"
    }
  }, [_vm._v("Sales at SK")])])], 1), _vm._v(" "), _c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "arrowDown": ""
    }
  })], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', [_c('sk-list-tile-content', _vm._l((_vm.items), function(item, index) {
    return (item.footer == 2) ? _c('sk-list-tile-title', {
      key: index
    }, _vm._l((item.children), function(child, index) {
      return _c('div', [(!child.url) ? _c('sk-button', {
        attrs: {
          "link": "",
          "router": "",
          "to": {
            name: child.name
          },
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))]) : _c('sk-button', {
        attrs: {
          "link": "",
          "tag": "a",
          "href": child.url,
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))])], 1)
    })) : _vm._e()
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-list', [_c('sk-list-group', [_c('sk-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('sk-list-tile-content', [_c('sk-list-tile-title', [_vm._v("SK Corporate")])], 1), _vm._v(" "), _c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "arrowDown": ""
    }
  })], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', [_c('sk-list-tile-content', _vm._l((_vm.items), function(item, index) {
    return (item.footer == 3) ? _c('sk-list-tile-title', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-list', [_c('sk-list-group', [_c('sk-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('sk-list-tile-content', [_c('sk-list-tile-title', [_vm._v("SK Clubs & Movie Cards")])], 1), _vm._v(" "), _c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "arrowDown": ""
    }
  })], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', [_c('sk-list-tile-content', _vm._l((_vm.items), function(item, index) {
    return (item.footer == 4) ? _c('sk-list-tile-title', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-list', [_c('sk-list-group', [_c('sk-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('sk-list-tile-content', [_c('sk-list-tile-title', [_vm._v("Share the Experience")])], 1), _vm._v(" "), _c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "arrowDown": ""
    }
  })], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', [_c('sk-list-tile-content', _vm._l((_vm.items), function(item, index) {
    return (item.footer == 5) ? _c('sk-list-tile-title', {
      key: index
    }, [(!item.url) ? _c('sk-button', {
      attrs: {
        "link": "",
        "router": "",
        "to": {
          name: item.name
        },
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('sk-button', {
      attrs: {
        "link": "",
        "tag": "a",
        "href": item.url,
        "contextValue": "Footer Navigation"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-list', [_c('sk-list-group', [_c('sk-list-tile', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('sk-list-tile-content', [_c('sk-list-tile-title', [_vm._v("Legal")])], 1), _vm._v(" "), _c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "arrowDown": ""
    }
  })], 1)], 1), _vm._v(" "), _c('sk-list-item', [_c('sk-list-tile', _vm._l((_vm.items), function(item, index) {
    return (item.footer == 6) ? _c('sk-list-tile-content', {
      key: index
    }, _vm._l((item.children), function(child, index) {
      return _c('sk-list-tile-title', {
        key: index
      }, [(child.target != undefined) ? [(!child.url) ? _c('sk-button', {
        attrs: {
          "link": "",
          "router": "",
          "to": {
            name: child.name
          },
          "contextValue": "Footer Navigation",
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.name))]) : _c('sk-button', {
        attrs: {
          "link": "",
          "tag": "a",
          "href": child.url,
          "contextValue": "Footer Navigation",
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.name))])] : [(!child.url) ? _c('sk-button', {
        attrs: {
          "link": "",
          "router": "",
          "to": {
            name: child.name
          },
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))]) : _c('sk-button', {
        attrs: {
          "link": "",
          "tag": "a",
          "href": child.url,
          "contextValue": "Footer Navigation"
        }
      }, [_vm._v(_vm._s(child.name))])]], 2)
    })) : _vm._e()
  }))], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('sk-list', {
    staticClass: "footer-social-icons"
  }, [_c('sk-list-tile', {
    attrs: {
      "href": "https://www.facebook.com/sterkinekortheatres/",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "facebook": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', {
    staticClass: "hidden-xs"
  }, [_vm._v("\n                    Facebook\n                  ")])], 1), _vm._v(" "), _c('sk-list-tile', {
    attrs: {
      "href": "https://twitter.com/sterkinekor",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "twitter": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', {
    staticClass: "hidden-xs"
  }, [_vm._v("\n                    Twitter\n                  ")])], 1), _vm._v(" "), _c('sk-list-tile', {
    attrs: {
      "href": "https://www.instagram.com/sterkinekor/?hl=en",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "instagram": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', {
    staticClass: "hidden-xs"
  }, [_vm._v("\n                    Instagram\n                  ")])], 1), _vm._v(" "), _c('sk-list-tile', {
    attrs: {
      "href": "https://www.youtube.com/user/SterKinekorTheatres",
      "target": "_blank"
    }
  }, [_c('sk-list-tile-action', [_c('sk-icon', {
    attrs: {
      "youtube": ""
    }
  })], 1), _vm._v(" "), _c('sk-list-tile-content', {
    staticClass: "hidden-xs"
  }, [_vm._v("\n                    Youtube\n                  ")])], 1)], 1)], 1)], 1)], 1)], 1)], 2), _vm._v(" "), _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.subscribedDialog),
      callback: function($$v) {
        _vm.subscribedDialog = $$v
      },
      expression: "subscribedDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.subscribedDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.subscribedDialog = false
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Thank You!")]), _vm._v(" "), _c('p', [_vm._v("Your email " + _vm._s(_vm.newsletter_email) + " has successfully been subscribed.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.subscribedDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed12dff4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/site-footer/site-footer.vue
// module id = 827
// module chunks = 0